import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutConfirmationTable } from 'src/pages/Checkout/components/common/Table';
import { commonFormatCurrencyWithType } from 'src/utils/currency';

type Props = {
  model: CheckoutConfirmationResponseType['AuctionBuyItNowItemsSubSection'];
};

export const CheckoutConfirmationAuctionBuyItNowItems = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.auctionBuyItNowItems');

  const columns = [
    { name: model.ItemsTerminology.Singular || '', className: 'left' },
    model.ShowFairMarketValueColumn && { name: tHelper('fairMarketValue'), className: 'left' },
    { name: tHelper('price'), className: 'right' },
    { name: tHelper('quantity'), className: 'align-center' },
    { name: tHelper('total'), className: 'right' },
  ];

  return (
    <>
      <h2 className="section-header">{model.SectionHeader}</h2>
      <CheckoutConfirmationTable columns={columns} data={model.Items}>
        {(item) => (
          <>
            <td className="left">{item.ItemTitle}</td>
            {model.ShowFairMarketValueColumn && <td className="left">{item.FairMarketValueString}</td>}
            <td className="right">{commonFormatCurrencyWithType(item.Amount, model.CurrencyType)}</td>
            <td className="align-center">{item.Quantity}</td>
            <td className="right">
              {item.Amount * item.Quantity > 0
                ? commonFormatCurrencyWithType(item.Amount * item.Quantity, model.CurrencyType)
                : tHelper('free')}
            </td>
          </>
        )}
      </CheckoutConfirmationTable>
    </>
  );
});
